import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, FsCatalog } from '../../../types'
import { CmsConverterService, defaultFSCatalog } from '../../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class OpenPanelMainContentFullWidthConverter extends CmsConverterService<OpenPanelMainContentFullWidthData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      rows: formData.st_row ?? defaultFSCatalog
    }
  }
}

export const OPEN_PANEL_MAIN_CONTENT_FULL_WIDTH_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, OpenPanelMainContentFullWidthData>>('OpenPanelMainContentFullWidthConverter')

export interface OpenPanelMainContentFullWidthData extends ConvertedComponentData {
  rows: FsCatalog;
}
